<template>
  <div class="home-function-container" :class="{homeFuncDefalut:isZH,homeFuncEn:!isZH}">
    <div class="info">
      <h1>{{ $t('home.func.title') }}</h1>
      <p>{{ $t('home.func.desc1') }}</p>
      <p>{{ $t('home.func.desc2') }}</p>
    </div>
    <div class="item-container">
      <div class="item-body">
        <HomeFunctionItem item-title="home.func.item1.title" item-info="home.func.item1.info" item-info2="home.func.item1.info2" bg-image="1" item-img="1"/>
        <HomeFunctionItem item-title="home.func.item2.title" item-info="home.func.item2.info" item-info2="home.func.item2.info2" bg-image="2" item-img="2"/>
      </div>
      <div class="item-body">
        <HomeFunctionItem item-title="home.func.item3.title" item-info="home.func.item3.info" item-info2="home.func.item3.info2" bg-image="3" item-img="3"/>
        <HomeFunctionItem item-title="home.func.item4.title" item-info="home.func.item4.info" item-info2="home.func.item4.info2" bg-image="4" item-img="4"/>
      </div>
    </div>
  </div>
</template>

<script>
import HomeFunctionItem from './HomeFunctionItem'
export default {
  name: 'HomeFunction',
  data () {
    return {
      isZH: (navigator.language || navigator.browserLanguage).toLowerCase().includes('zh-cn')
    }
  },
  components: {
    HomeFunctionItem
  }
}
</script>

<style lang="less" scoped>
  .home-function-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    min-height: 102.5625rem;
    width: 100%;
    background-color: #F5F5F5;
    .info{
      display: flex;
      flex-direction: column;
      align-items: center;
      h1{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 3.625rem;
        line-height: 150%;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: -0.02em;
        background: linear-gradient(90deg, #50A9EA 4.94%, #1664FC 103.87%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      p{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 1.9375rem;
        line-height: 160%;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: -0.02em;
        color: #1A202C;
      }
    }
    .item-container{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 1.5625rem;
      .item-body{
        max-width: 75.0rem;
        display: flex;
        justify-content: space-between;
        padding: 2.5rem 0px;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .home-function-container{
      .info{
        h1{
          font-size: 23.2px;
        }
        p{
          font-size: 12.4px;
        }
      }
      .item-container{
        flex-direction: column;
        margin-top: 2px;
        .item-body{
          flex-direction: column;
          max-width: 500px;
          padding: 0px 0px;
        }
      }
    }
    &.homeFuncDefalut {
      min-height: 1471px;
      height: 1471px;
    }
    &.homeFuncEn {
      min-height: 1571px;
      height: 1571px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/subcomponents/HomeFunction.vue